import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { createSignal } from "solid-js";
import { useService } from "solid-services";
import { Flex, Stack } from "styled-system/jsx";
// Update this import to point to your new generic state file
import { useComments } from "./state";

interface PostProps {
  parentId?: string;
  onCancel?: () => void;
}

export const Post = (props: PostProps) => {
  // Use the generic service
  const { postMutation } = useService(useComments)();
  const [content, setContent] = createSignal("");

  const handlePost = async () => {
    if (!content().trim()) return;

    await postMutation.mutateAsync({
      content: content(),
      parentId: props.parentId
    });

    setContent(""); // Clear input on success
  };

  return (
    <Flex gap="3" width="full">
      <Stack width="full" gap="2">
        <Textarea
          placeholder={props.parentId ? "Write a reply..." : "Add a comment..."}
          value={content()}
          onInput={(e) => setContent(e.currentTarget.value)}
          autofocus={!!props.parentId}
        />
        <Flex justify="flex-end" gap="2">
          {props.onCancel && (
            <Button variant="outline" size="sm" onClick={props.onCancel} disabled={postMutation.isPending}>
              Cancel
            </Button>
          )}
          <Button
            size="sm"
            onClick={handlePost}
            loading={postMutation.isPending}
            disabled={!content().trim()}
          >
            {props.parentId ? 'Reply' : 'Post Comment'}
          </Button>
        </Flex>
      </Stack>
    </Flex>
  );
};
